export default __webpack_public_path__ + "static/media/logoGPMET.b24b2cfc.png";